// src/tokens/breakpoint.ts
var breakpointXsmall = 0;
var breakpointSmall = 375;
var breakpointMedium = 768;
var breakpointLarge = 1024;
var breakpointXlarge = 1440;
var breakpoint2xlarge = 1920;
export { breakpointXsmall, breakpointSmall, breakpointMedium, breakpointLarge, breakpointXlarge, breakpoint2xlarge };